<template>
  <div>
    <pcHeaders></pcHeaders>

    <div class="loginBanner">
      <div class="cent">
        <div>
          <div class="title">安全生产学习平台</div>

          <div class="sof">
            <img src="../assets/images/loginBc.png" alt="安全生产学习平台" />
          </div>
        </div>
        <div class="xian"></div>

        <div class="forms">
          <div class="qs">账号</div>
          <el-input v-model="userInfo.userName" class="sr" placeholder="用户名/身份证号/手机号"></el-input>

          <div class="qs" style="margin-top: 20px">密码</div>
          <el-input type="password" v-model="userInfo.userPasswd" class="sr" placeholder="请输入密码"></el-input>
          <el-button class="loginBtn" @click="login">立即登录</el-button>

          <div class="lognBtm">
            <div class="wj" @click="showDig">忘记密码</div>
            <div class="wj" style="color: #436cf3" @click="goRegist">快速注册</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="重置密码" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <div style="margin: 0 auto; width: 80%" v-if="nax == 1">
        <div class="forms">
          <div class="qs">手机号:</div>
          <el-input v-model="resetting.mobile" class="sr" style="margin-top: 8px" placeholder="请输入手机号"></el-input>

          <div class="qs" style="margin-top: 20px">验证码:</div>
          <div style="display: flex">
            <el-input
              type="text"
              v-model="resetting.checkcode"
              class="sr"
              style="margin-top: 8px; width: 190px"
              placeholder="请输入验证码"
            ></el-input>
            <img
              style="height: 40px; width: 90px; margin-top: 8px; margin-left: 10px; cursor: pointer"
              @click="captchaImage"
              :src="'data:image/png;base64,' + codeImgInfo.img"
            />
          </div>
          <div style="">
            <div class="qs" style="margin-top: 20px">短信验证码:</div>
            <div style="display: flex">
              <el-input
                type="text"
                v-model="resetting.dxCode"
                class="sr"
                style="margin-top: 8px; width: 180px; margin-right: 10px"
                placeholder="请输入验证码"
              ></el-input>
              <el-button type="primary" style="margin-top: 8px; text-align: center" v-if="!isCounting" @click="getCode">{{
                buttonText
              }}</el-button>
              <el-button type="primary" style="margin-top: 8px; text-align: center" v-if="isCounting">{{ countdown }}s后重新发送</el-button>
            </div>
            <!-- <el-button type="primary"
                       style="margin:  20px 0;"
                       @click="nextOne(2)">下一步</el-button> -->
          </div>
          <div class="qs" style="margin-top: 8px">请输入新密码:</div>
          <el-input v-model="resetting.newPass1" class="sr" style="margin-top: 8px; width: 270px" placeholder="请输入新密码"></el-input>

          <div style="display: flex; justify-content: center">
            <el-button type="primary" style="margin: 20px 0" @click="subMit">提交</el-button>
          </div>
        </div>
      </div>

      <!-- <div style="margin: 0 auto; width: 80%" v-if="nax == 2">
        <div class="forms">
          <div class="qs" style="margin-top: 20px">短信验证码:</div>
          <div style="display: flex">
            <el-input
              type="text"
              v-model="dxCode"
              class="sr"
              style="margin-top: 8px; width: 180px; margin-right: 10px"
              placeholder="请输入验证码"
            ></el-input>
            <el-button type="primary" style="margin-top: 8px; text-align: center" v-if="!isCounting" @click="getCode">{{
              buttonText
            }}</el-button>
            <el-button type="primary" style="margin-top: 8px; text-align: center" v-if="isCounting">{{ countdown }}s后重新发送</el-button>
          </div>
          <div style="display: flex; justify-content: center">
            <el-button type="primary" style="margin: 20px 0" @click="nextOne(3)">下一步</el-button>
          </div>
        </div>
      </div>

      <div style="margin: 0 auto; width: 80%" v-if="nax == 3">
        <div class="forms">
          <div style="color: #436cf3">姓名：{{ reseUserInfo.realname }}</div>
          <div style="color: #436cf3">身份证号：{{ reseUserInfo.cardno }}</div>
          <div class="qs" style="margin-top: 8px">请输入新密码:</div>
          <el-input v-model="updataPsd.newPass1" class="sr" style="margin-top: 8px; width: 270px" placeholder="请输入新密码"></el-input>

          <div class="qs" style="margin-top: 8px">确认新密码:</div>
          <el-input v-model="updataPsd.newPass2" class="sr" style="margin-top: 8px; width: 270px" placeholder="确认新密码"></el-input>

          <div style="display: flex; justify-content: center">
            <el-button type="primary" style="margin: 20px 0" @click="subMit">完成</el-button>
          </div>
        </div>
      </div> -->
    </el-dialog>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../views/component/head.vue';
import pcBottom from '../views/component/bottom.vue';
import { mapMutations } from 'vuex';
import { captchaImage, login, toCheckPhone, sendDx, toCheckPhone2, toResetPassword3, toUpdatePass } from '@/api/login.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      userInfo: {
        userName: '',
        userPasswd: '',
        equipment: '01'
      },
      dialogVisible: false,
      nax: 1, //忘记密码下一步
      codeImgInfo: {},
      resetting: {
        mobile: '',
        checkcode: '',
        dxCode: '',
        newPass1: ''
      },
      resePhoneInfo: {}, //第二步使用
      countdown: 60, // 默认倒计时为60秒
      isCounting: false, // 标记是否正在进行倒计时
      buttonText: '获取验证码', // 按钮文字
      dxCode: '',
      reseUserInfo: {}, //修改密码的用户资料
      updataPsd: {
        newPass1: '',
        newPass2: ''
      },
      restPath: '',
      uuid: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.fromPath = from.path;
    });
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken', 'REAL_NAME']),
    ...mapMutations('m_user', ['updateToken', 'USER_NAME']),
    goRegist() {
      this.$router.push('/regist');
    },
    //更新密码
    //忘记密码提交
    subMit() {
      if (!this.resetting.mobile) {
        this.$message.error('请输入手机号');
        return false;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.resetting.mobile)) {
        this.$message.error('请输入正确的手机号');
        return false;
      }
      if (!this.resetting.checkcode) {
        this.$message.error('请输入图形验证码');
        return false;
      }
      if (!this.resetting.dxCode) {
        this.$message.error('请输入短信验证码');
        return false;
      }
      if (!this.resetting.newPass1) {
        this.$message.error('请输入密码');
        return false;
      }

      if (this.resetting.newPass1.length < 6 || this.resetting.newPass1.length > 20) {
        this.$message.error('密码长度应为6-20位');
        return false;
      }
      this.isRegis = true;
      toUpdatePass({
        mobile: this.resetting.mobile,
        imgCode: this.resetting.checkcode,
        newPass: this.resetting.newPass1,
        logo: this.uuid,
        check_code: this.resetting.dxCode
      })
        .then(res => {
          if (res.data.data.code == '1') {
            this.$message.success('密码修改成功');
            this.dialogVisible = false;
            // setTimeout(() => {
            //   this.$router.replace('/login');
            // }, 1000);
          } else {
            this.$message.error(res.data.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(res.data.msg || '修改失败，请重试');
          this.getImg();
        })
        .finally(() => {
          this.isRegis = false;
        });
    },
    //获取手机短信
    getCode() {
      // 先校验手机号
      if (!this.resetting.mobile) {
        this.$message.error('请先输入手机号', 1500);
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.resetting.mobile)) {
        this.$message.error('请输入正确的手机号', 1500);
        return;
      }
      // 再校验图形验证码
      if (!this.resetting.checkcode) {
        this.$message.error('请先输入图形验证码', 1500);
        return;
      }
      // 发送短信验证码
      sendDx({ mobile: this.resetting.mobile, imgCode: this.resetting.checkcode, logo: this.uuid })
        .then(res => {
          if (res.data.data.code == '1') {
            this.$message.success('短信验证码已发送', 1500);
            this.startCountDown();
          } else if (res.data.data.code == '4') {
            this.$message.error('图形验证码错误', 1500);
            setTimeout(() => {
              this.resetting.checkcode = '';
              this.captchaImage();
            }, 1000);
          } else if (res.data.data.code == '5') {
            this.$message.error(res.data.data.msg, 1500);
          } else {
            this.$message.error(res.data.data.msg, 1500);
          }
        })
        .catch(err => {
          this.captchaImage();
          this.$message.error('发送失败，请重试', 1500);
        });
    },
    startCountDown() {
      let timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(timer);

          this.resetButtonState();
        }
      }, 1000);

      this.isCounting = true;
    },

    resetButtonState() {
      this.isCounting = false;
      this.countdown = 60;
      this.buttonText = '获取验证码';
    },
    // nextOne(id) {
    //   if (id == 2) {
    //     if (this.resetting.mobile == '' || this.resetting.checkcode == '') {
    //       this.$message.error('请填写完全！');
    //       return false;
    //     }
    //     this.resetting.logo = this.codeImgInfo.uuid;
    //     toCheckPhone(this.resetting).then(res => {
    //       if (res.data.data.code == '1') {
    //         this.resePhoneInfo = res.data.data;
    //         this.nax = id;
    //       } else {
    //         this.$message.error(res.data.data.msg);

    //         return false;
    //       }
    //     });
    //   } else if (id == 3) {
    //     if (this.dxCode == '') {
    //       this.$message.error('短信验证码为空！');
    //       return false;
    //     }
    //     let data = {
    //       logo: this.resetting.logo,
    //       check_code: this.dxCode
    //     };
    //     toCheckPhone2(data).then(res => {
    //       console.log(res.data.data);
    //       if (res.data.data.code == '1') {
    //         let query = {
    //           logo: this.resetting.logo,
    //           USERID_TO_RESET_PASS: this.resePhoneInfo.USERID_TO_RESET_PASS
    //         };
    //         toResetPassword3(query).then(respos => {
    //           if (respos.data.data.code == '1') {
    //             this.reseUserInfo = respos.data.data;
    //             this.nax = id;
    //           } else {
    //             this.$message.error(respos.data.data.msg);
    //             return false;
    //           }
    //         });
    //       } else {
    //         this.$message.error(res.data.data.msg);
    //         return false;
    //       }
    //     });
    //   }
    // },
    captchaImage() {
      captchaImage().then(res => {
        this.codeImgInfo = res.data;
        this.uuid = res.data.uuid;

        console.log(res, '4444');
      });
    },
    login() {
      if (this.userInfo.userName == '' || this.userInfo.userName == undefined) {
        this.$message({
          message: '请输入账号！',
          type: 'warning'
        });
        return false;
      } else if (this.userInfo.userPasswd == '' || this.userInfo.userPasswd == undefined) {
        this.$message({
          message: '请输入密码！',
          type: 'warning'
        });
        return false;
      }
      login(this.userInfo).then(res => {
        if (res.data.msg == '登录成功') {
          this.updateToken(res.data.token);
          this.REAL_NAME(res.data.realName);
          this.USER_NAME(res.data.userName);
          // 拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('realName', res.data.realName);
          localStorage.setItem('userName', res.data.userName);
          localStorage.removeItem('bmShow');
          // this.$message({
          //   message: res.data.msg,
          //   type: 'success',
          //   duration:800
          // });

          if (this.fromPath == '/toPayOrder') {
            this.$router.replace('/studyMain');
            return false;
          }
          if (this.fromPath == '/regist') {
            this.$router.push('/studyMain');
          } else {
            this.$router.back();
          }
        } else {
          // this.$message.error(res.data.msg);
        }
      });
    },
    showDig() {
      this.nax = 1;
      captchaImage().then(res => {
        this.codeImgInfo = res.data;
        this.uuid = res.data.uuid;

        this.dialogVisible = true;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.el-form-item /deep/ .item__content {
  margin-left: 0 !important;
}
.loginBanner {
  width: 100%;
  min-height: 750px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  padding-top: 46px;
  font-family: Regular;
  padding-bottom: 200px;
  .cent {
    width: 920px;
    height: 380px;
    background: #ffffff;
    opacity: 1;
    border-radius: 0px;
    display: flex;
    padding: 57px 50px;
    .title {
      width: 410px;
      font-size: 24px;
      font-family: bold;
      color: #333333;
      text-align: center;
    }
    .sof {
      margin-top: 32px;
    }
    img {
      width: 380px;
      height: 201px;
    }
    .xian {
      margin: 44px 0 0 61px;
      height: 180px;
      border: 1px solid #eeeeee;
    }
    .forms {
      margin-left: 60px;
      .qs {
        font-size: 16px;
        font-family: Medium;
        color: #333333;
      }
      .sr {
        margin-top: 8px;
        width: 300px;
        height: 42px;
        opacity: 1;
        border-radius: 4px;
        color: #a3a3a3;
      }

      .loginBtn {
        margin-top: 28px;
        width: 300px;
        height: 46px;
        background: #436cf3;
        opacity: 1;
        border-radius: 4px;
        color: #fff;
      }
      .lognBtm {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        .wj {
          color: #a3a3a3;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
